import { render, staticRenderFns } from "./JobEconomicAdvanceTable.vue?vue&type=template&id=203770a8&scoped=true&"
import script from "./JobEconomicAdvanceTable.vue?vue&type=script&lang=js&"
export * from "./JobEconomicAdvanceTable.vue?vue&type=script&lang=js&"
import style0 from "./JobEconomicAdvanceTable.vue?vue&type=style&index=0&id=203770a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203770a8",
  null
  
)

export default component.exports